var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirginOliveOil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.353,
    height: 17.988,
    viewBox: "0 0 18.353 17.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3382",
    "data-name": "Group 3382",
    transform: "translate(0.35 0.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3518",
    "data-name": "Path 3518",
    d: "M1971.484,193.662a.349.349,0,0,1-.268-.125,14.217,14.217,0,0,1-2.97-7.232.35.35,0,0,1,.7-.057,13.757,13.757,0,0,0,2.809,6.839.35.35,0,0,1-.268.575Z",
    transform: "translate(-1963.218 -186.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3519",
    "data-name": "Path 3519",
    d: "M1946.8,196.119a.35.35,0,0,1-.35-.338,13.093,13.093,0,0,1,.739-5.131,8.2,8.2,0,0,1,1.942-3,6.61,6.61,0,0,1,2.964-1.717.35.35,0,0,1,.142.685,6.047,6.047,0,0,0-2.648,1.562,7.523,7.523,0,0,0-1.756,2.745,11.949,11.949,0,0,0-.693,4.222c1.13-.744,3.814-2.79,4.508-5.813a.35.35,0,0,1,.682.157,9.715,9.715,0,0,1-3.047,4.875,12.871,12.871,0,0,1-2.315,1.71A.35.35,0,0,1,1946.8,196.119Z",
    transform: "translate(-1946.785 -186.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3189",
    "data-name": "Group 3189",
    transform: "translate(5.086 7.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3520",
    "data-name": "Path 3520",
    d: "M1983.474,232.586a3.3,3.3,0,0,1,2.748,2.139,3.893,3.893,0,0,1,.306,2.321,2.141,2.141,0,0,1-1.182,1.614,1.865,1.865,0,0,1-.765.161,3.3,3.3,0,0,1-2.748-2.139,3.893,3.893,0,0,1-.306-2.321,2.141,2.141,0,0,1,1.182-1.614A1.866,1.866,0,0,1,1983.474,232.586Zm1.107,5.534a1.169,1.169,0,0,0,.48-.1,1.465,1.465,0,0,0,.781-1.113,3.189,3.189,0,0,0-.259-1.9,2.639,2.639,0,0,0-2.109-1.724,1.17,1.17,0,0,0-.48.1c-.858.382-1.092,1.733-.522,3.011A2.639,2.639,0,0,0,1984.581,238.121Z",
    transform: "translate(-1978.265 -228.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3521",
    "data-name": "Path 3521",
    d: "M1996.427,217.276a.35.35,0,0,1-.349-.329,3.114,3.114,0,0,0-.886-1.878c-.917-.974-2.228-1.3-2.923-.73a.35.35,0,0,1-.445-.541c.99-.815,2.693-.467,3.877.791a3.82,3.82,0,0,1,1.075,2.316.35.35,0,0,1-.329.37Z",
    transform: "translate(-1985.974 -213.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3522",
    "data-name": "Path 3522",
    d: "M2003.227,235.712a3.025,3.025,0,0,1-2.376-1.465.35.35,0,1,1,.579-.393,2.022,2.022,0,0,0,2.275,1.059,1.465,1.465,0,0,0,.781-1.113,3.19,3.19,0,0,0-.259-1.9c-.57-1.278-1.731-2.006-2.589-1.624a1.59,1.59,0,0,0-.823,1.43.35.35,0,0,1-.7-.05,2.289,2.289,0,0,1,1.237-2.019,2.141,2.141,0,0,1,1.991.2,4.114,4.114,0,0,1,1.828,4.1,2.141,2.141,0,0,1-1.182,1.614A1.864,1.864,0,0,1,2003.227,235.712Z",
    transform: "translate(-1992.319 -225.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3523",
    "data-name": "Path 3523",
    d: "M1980.476,218.664a.35.35,0,0,1-.344-.419,3.447,3.447,0,0,0-1.224-3.169,1.606,1.606,0,0,0-1.624-.352,1.734,1.734,0,0,0-.828,1.747.35.35,0,0,1-.335.364h-.015a.35.35,0,0,1-.349-.336,2.406,2.406,0,0,1,1.242-2.415,2.247,2.247,0,0,1,2.346.445,4.114,4.114,0,0,1,1.473,3.854A.35.35,0,0,1,1980.476,218.664Z",
    transform: "translate(-1973.963 -214.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3524",
    "data-name": "Path 3524",
    d: "M1970.283,232.913a2.556,2.556,0,0,1-1.454-.5,4.192,4.192,0,0,1-1.452-1.921,4.145,4.145,0,0,1-.2-2.484,2.269,2.269,0,0,1,1.334-1.648,2.672,2.672,0,0,1,3.009,1.182.35.35,0,0,1-.558.423,2.032,2.032,0,0,0-2.2-.953,1.594,1.594,0,0,0-.909,1.167,3.441,3.441,0,0,0,.179,2.059c.525,1.351,1.674,2.2,2.614,1.922a.35.35,0,0,1,.2.672A1.984,1.984,0,0,1,1970.283,232.913Z",
    transform: "translate(-1967.416 -223.406)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3190",
    "data-name": "Group 3190",
    transform: "translate(5.377 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3525",
    "data-name": "Path 3525",
    d: "M1977.666,191.295c-4.28,0-6.66-1.584-7.934-3.008a.35.35,0,0,1,.522-.467c1.279,1.429,3.784,3.03,8.5,2.741a14.783,14.783,0,0,0-2.556-2.737,10.085,10.085,0,0,0-3.283-1.847,7.585,7.585,0,0,0-4.238-.131.35.35,0,1,1-.172-.679,8.275,8.275,0,0,1,4.635.147,10.8,10.8,0,0,1,3.518,1.981,14.877,14.877,0,0,1,3.023,3.386.35.35,0,0,1-.267.53C1978.8,191.268,1978.217,191.295,1977.666,191.295Z",
    transform: "translate(-1968.595 -185.255)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirginOliveOil);
export default __webpack_public_path__ + "static/media/virgin_olive_oil.71270a17522cde702fc3209ba487e246.svg";
export { ForwardRef as ReactComponent };